// SharedStateContext.tsx
import React, { createContext, useState, useContext, ReactNode } from 'react';
import { useMediaQuery } from 'react-responsive';

// Define the shape of the shared state context
interface SharedStateContextType {
  sharedState: boolean;
  setSharedState: React.Dispatch<React.SetStateAction<boolean>>;
  isMobile: boolean;
}

// Create the context with a default value
const SharedStateContext = createContext<SharedStateContextType | undefined>(undefined);

// Provider component
interface SharedStateProviderProps {
  children: ReactNode;
}

export const SharedStateProvider: React.FC<SharedStateProviderProps> = ({ children }) => {
  const [sharedState, setSharedState] = useState<boolean>(false);
  
  // Use react-responsive to check if the screen width is 768px or smaller
  const isMobile = useMediaQuery({ maxWidth: 819 });

  return (
    <SharedStateContext.Provider value={{ sharedState, setSharedState, isMobile }}>
      {children}
    </SharedStateContext.Provider>
  );
};

// Custom hook to use the shared state context
export const useSharedState = (): SharedStateContextType => {
  const context = useContext(SharedStateContext);
  if (!context) {
    throw new Error('useSharedState must be used within a SharedStateProvider');
  }
  return context;
};
